import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsServicedeskIssuetypesRoute: InvariantJiraRoute = {
	name: 'project-settings-servicedesk-issuetypes',
	path: '/jira/servicedesk/projects/:projectKey/settings/issuetypes/:issueTypeId?',
	exact: true,
};
